export const sortDSPOptions = <T extends { name: string; show_on_top?: number }>(
  options: Record<string, T | undefined> = {}
): string[] => {
  return Object.keys(options).sort((a, b) => {
    if (options[a]?.show_on_top !== undefined && options[b]?.show_on_top === undefined) return -1;
    else if (options[a]?.show_on_top === undefined && options[b]?.show_on_top !== undefined) return 1;
    else if (options[a]?.show_on_top !== undefined && options[b]?.show_on_top !== undefined) {
      const diff = (options[a].show_on_top || 0) - (options[b].show_on_top || 0);
      if (diff !== 0) return diff;
    }

    return (options[a]?.name.toLowerCase() || '').localeCompare(options[b]?.name.toLowerCase() || '', undefined, {
      sensitivity: 'base',
    });
  });
};
